import React from 'react';
import { faqData } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-purple-200/50 relative overflow-hidden">
      {/* Background Decorations - contained within section */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-[#7ed321]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-[#6b2d7b]/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#7ed321]/20 mb-6">
            <HelpCircle className="w-8 h-8 text-[#6b2d7b]" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#6b2d7b] mb-4">
            {faqData.title}
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            {faqData.subtitle}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-2xl border border-slate-100 px-6 shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden"
            >
              <AccordionTrigger className="text-left py-6 text-lg font-semibold text-[#6b2d7b] hover:text-[#7ed321] transition-colors [&[data-state=open]]:text-[#7ed321]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-slate-600 leading-relaxed text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-slate-600 mb-4">
            Still have questions? We're here to help.
          </p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center text-[#6b2d7b] font-semibold hover:text-[#7ed321] transition-colors"
          >
            Contact us for more information →
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
